import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import DownloadBanner from '../components/DownloadBanner';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <Hero />
      <Features />
      <DownloadBanner />
    </div>
  );
};

export default Home;
